import { Inline } from "PFComponents/containers";
import {
  getPillIconsCount,
  getSmartMaxNameLength
} from "PFComponents/custom_value_pill/custom_value_pill.utils";
import { Typography } from "PFComponents/typography";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { CustomValue } from "PFCore/types";
import spacing from "PFTheme/tokens/spacing";

import { CustomValuesListCommonProps } from "./custom_values_list.consts";

const EXPERIENCE_LEVEL_WIDTH = 33.33;
const ICON_SIZE = 16;
const PILL_PADDING = spacing.spacingXs;
const DIVIDER_WIDTH = 1;
const IN_PILL_GAP = spacing.spacingSm;

type PlaceholderCustomValuesListProps = Pick<CustomValuesListCommonProps, "maxNameLength"> & {
  customValues: CustomValue[];
};

// This component renders a simplified version of the `ProfileCustomValuesList`
// to approximate its size without rendering the full component
export const PlaceholderCustomValuesList = ({
  customValues,
  maxNameLength = 40
}: PlaceholderCustomValuesListProps) => (
  <Inline rowGap="spacingLg" columnGap="spacingMd" wrap="wrap">
    {customValues.map((customValue) => {
      const name = String(customValue.value ?? customValue.text);
      const tags = getAttribute(customValue, "tagIds") || [];
      const hasTags = tags.length > 0;
      const isCore = customValue.top;
      const isDevelopmental = customValue.developmental;
      const isVerified = customValue.assessed;
      const isVerifiedOthers = getAttribute(customValue, "emVerified");
      const smartMaxNameLength = getSmartMaxNameLength({
        maxNameLength,
        isCore,
        isDevelopmental,
        isVerified,
        isVerifiedOthers,
        hasTags
      });
      const isNameTooLong = name.length > smartMaxNameLength;
      const iconsCount = getPillIconsCount({
        isCore,
        isDevelopmental,
        isVerified,
        isVerifiedOthers,
        hasTags
      });

      return (
        <Inline gap="spacingMd" key={customValue.id}>
          <Inline gap={null} style={{ padding: PILL_PADDING }}>
            <div style={{ width: EXPERIENCE_LEVEL_WIDTH }} />
            <div style={{ width: IN_PILL_GAP }} />
            <Typography variant="labelButton">
              {name.slice(0, smartMaxNameLength)}
              {isNameTooLong && "..."}
            </Typography>
            {iconsCount > 0 && (
              <>
                <div style={{ width: IN_PILL_GAP }} />
                <div style={{ width: iconsCount * ICON_SIZE, height: ICON_SIZE }} />
                <div style={{ width: `calc((${iconsCount} - 1) * ${IN_PILL_GAP})` }} />
              </>
            )}
          </Inline>
          <div style={{ width: DIVIDER_WIDTH }} />
        </Inline>
      );
    })}
  </Inline>
);
